import * as types from './types'

export const completeItem = (bundleId, itemId) => ({
  type: types.COMPLETE_ITEM,
  payload: { bundleId, itemId },
})

export const uncompleteItem = (bundleId, itemId) => ({
  type: types.UNCOMPLETE_ITEM,
  payload: { bundleId, itemId },
})
